import { Azing } from './azing-interface/azing.model';
import { Info } from './info';
import { Polymorph } from './polymorph';
import { throwException } from './service-exception';

declare const azing: Azing;

export class AzingManagerService {
  private host: string;
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> } = window;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(host: string) {
    this.host = host;
  }

  private baseUrl(): string {
    return this.host + '/API/2sxc/app/azingManager/' + Polymorph.GetApiCatLocation() + '/api/';
  }

  /**
   * @return Promise<Info>
   */
  info(): Promise<Info> {
    const url = this.baseUrl() + 'me/info';

    const options = {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    } as RequestInit;

    return this.http.fetch(url, options).then((response: Response) => {
      return this.processInfo(response);
    });
  }

  protected processInfo(response: Response): Promise<Info> {
    const status = response.status;

    const headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => headers[k] = v);
    }

    if (status === 200) {
      return response.text().then((responseText) => {
        const data = responseText === '' ? null : JSON.parse(responseText, this.jsonParseReviver);
        const info = data ? Info.fromJS(data) : new Info();

        // add new User to info$ observable
        azing.info$.next(info);

        return info;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((responseText) => {
        return throwException('An unexpected server error occurred.', status, responseText, headers);
      });
    }

    return Promise.resolve<Info>(null as any);
  }
}
